import { Grid } from '@mui/material';
import { Breakpoint } from '@mui/system';
import { usePrint } from '@procureai/ui-mui';
import { PropsWithChildren, ReactNode } from 'react';

import { PageLayout } from '~/components/PageLayout/PageLayout';

export type ModulePageProps = {
  header: ReactNode;
  modules: ReactNode;
  drawer?: ReactNode;
  maxWidth?: Breakpoint | false;
};

export const ModulePage = ({ header, modules, drawer, children }: PropsWithChildren<ModulePageProps>) => {
  const { isPrinting } = usePrint();
  return (
    <>
      {header}

      <PageLayout>
        <Grid
          container
          direction="row"
          spacing={4}
          data-intercom-target="ModulePage/Modules"
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            alignContent: 'flex-start',
            display: isPrinting ? 'inline' : 'flex',
          }}
        >
          {modules}
        </Grid>
        {children}
      </PageLayout>

      {drawer}
    </>
  );
};
